/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXIcon16Solid = forwardRef('DataChartBarsXIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12 1a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M7 4a1 1 0 0 0-2 0v7a1 1 0 1 0 2 0V4Z" }),
        React.createElement("path", { d: "M9 5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M3 7a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M1 13a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2H1Z" })));
});
